import "components/pages/insGridPage.scss";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGetDatapointsDataWithFilters } from "../hooks/useGetDatapointsDataWithFilters";
import { PortfolioCreationChoice } from "../types";
import { DatapointIdStandardEnum } from "api/ux/src";
import { addCustomFieldsAsCols, addCustomFieldsAsDatapoints } from "components/modal/portfolio-creation-edit/helper";
import { InsGridWidget } from "components/widgets";
import { InsGridAggs } from "components/widgets/grid/grid-agg-funcs";
import { CustomColumnType } from "components/widgets/grid/grid-column-types";
import { getDefaultMappings, insDatapointGridWidgetAdapterData } from "components/widgets/grid/insDatapointGridWidgetAdapter";
import { getMeasuresAndDimensionsWithCurrency } from "hooks/use-funds-page";
import { useGetCustomDatapointDimensionsByPortfolioCreationChoice } from "hooks/widget-data/use-datapoints";
import { useRefreshOnUserSettingsChange } from "hooks/widget-data/user-settings/user-settings";
import { setSelectedRowsState } from "store/grids";
import { AddInvestorAccountsOrFundsMode } from "store/modal/portfolio-creation-types";
const getMeasuresAndDimensions = (customFields) => {
    const datapoints = [
        { datapoint: { standard: DatapointIdStandardEnum.FundFundId }, name: "Id" },
        { datapoint: { standard: DatapointIdStandardEnum.FundInvestorId }, name: "InvestorId" },
        { datapoint: { standard: DatapointIdStandardEnum.FundFundName }, name: "Name" },
        { datapoint: { standard: DatapointIdStandardEnum.FundCurrency }, name: "Currency" },
        { datapoint: { standard: DatapointIdStandardEnum.FundInvestorName }, name: "InvestorName" },
        { datapoint: { standard: DatapointIdStandardEnum.FundInvestorCurrency }, name: "InvestorCurrency" },
        { datapoint: { standard: DatapointIdStandardEnum.FundVintageYear }, name: "Vintage" },
        { datapoint: { standard: DatapointIdStandardEnum.FundStrategy }, name: "Strategy" },
        { datapoint: { standard: DatapointIdStandardEnum.FundGeography }, name: "Geography" },
        { datapoint: { standard: DatapointIdStandardEnum.FundCommitment }, name: "Commitment" }
    ];
    addCustomFieldsAsDatapoints(customFields, datapoints);
    // Group by fund and investor id
    return getMeasuresAndDimensionsWithCurrency(["InvestorId", "Id"], datapoints);
};
const useCreateColInsFunds = (customFields) => {
    const cols = [
        { field: "Id", hide: true, lockVisible: true },
        { field: "InvestorId", hide: true, lockVisible: true },
        { field: "Name", headerName: "Fund", sort: "asc", type: CustomColumnType.AUX_TEXT_COLUMN },
        { field: "Currency", headerName: "Fund Currency", type: CustomColumnType.AUX_TEXT_COLUMN, width: 80 },
        { field: "InvestorName", headerName: "Investor Account", type: CustomColumnType.AUX_TEXT_COLUMN },
        { field: "InvestorCurrency", headerName: "Investor Currency", type: CustomColumnType.AUX_TEXT_COLUMN, width: 80 },
        { aggFunc: InsGridAggs.totalData, field: "Commitment", type: CustomColumnType.InsMoneyColumn, width: 120 },
        { field: "Vintage", type: CustomColumnType.AUX_TEXT_COLUMN, width: 80 },
        { field: "Strategy", type: CustomColumnType.AUX_TEXT_COLUMN },
        { field: "Geography", type: CustomColumnType.AUX_TEXT_COLUMN }
    ];
    addCustomFieldsAsCols(customFields, cols);
    return cols;
};
export const portfolioCreationRulesBasedGridId = "portfolio-creation-rules-based-grid";
export const InsPortfolioCreationRulesBasedGrid = () => {
    const dispatch = useDispatch();
    const listOfCustomFields = useGetCustomDatapointDimensionsByPortfolioCreationChoice(PortfolioCreationChoice.CreatePortfolioRuleBased);
    const { measures, dimensions } = getMeasuresAndDimensions(listOfCustomFields);
    const [data, querystate, refresh] = useGetDatapointsDataWithFilters(dimensions, measures, portfolioCreationRulesBasedGridId, true, AddInvestorAccountsOrFundsMode.Default);
    useRefreshOnUserSettingsChange();
    const cols = useCreateColInsFunds(listOfCustomFields);
    const { rows, totals } = insDatapointGridWidgetAdapterData(data, cols);
    const defaultLinksMapping = getDefaultMappings([{ dimensions, id: "", measures }], cols);
    const portfolioCurrency = useSelector((state) => state.portfolioCreation.information.currency);
    const currencies = [...new Set([portfolioCurrency, ...rows?.map((r) => r.Currency || "") || []])].filter((c) => c);
    return React.createElement(React.Fragment, null,
        React.createElement(InsGridWidget, { rowSelectedHandler: ((e) => {
                dispatch(setSelectedRowsState({ id: portfolioCreationRulesBasedGridId,
                    selectedRows: e.api.getSelectedRows()
                        .map((row) => `${row.Id}-${row.InvestorId}`) }));
            }), selectionMode: "multiple", widgetId: portfolioCreationRulesBasedGridId, stateId: portfolioCreationRulesBasedGridId, columnDefs: cols, rowData: rows, refreshAction: refresh, totalData: totals, currencyData: currencies, queryState: querystate, suppressRowClickSelection: true, context: { linksMapping: defaultLinksMapping }, hideFilters: true }));
};
